import React, { Component } from "react";
import PropTypes from 'prop-types';
import CurrencyConverter from "../../CurrencyConverter/CurrencyConverter";
import { FormattedMessage } from "react-intl";
import messages from "../../../locale/messages";
import s from "./ListingItem.css";

class ShowPrice extends Component {

    static propTypes = {
        totalPrice: PropTypes.bool,
        basePrice: PropTypes.number,
        oneTotalPrice: PropTypes.number,
        currency: PropTypes.string,
        calculatedValues: PropTypes.object,
    };

    render() {
        const { totalPrice, basePrice, currency, calculatedValues } = this.props;

        // Use pre-calculated values from calculateTotalPrice
        let displayPrice = basePrice;
        let displayTotalPrice = calculatedValues?.oneTotalPrice;

        if (calculatedValues?.isAverage > 0) {
            displayPrice = calculatedValues.isAverage;
        }

        if (calculatedValues?.oneTotalPrice > 0) {
            displayTotalPrice = calculatedValues.oneTotalPrice;
        }

        return (
            <>
                <CurrencyConverter
                    amount={totalPrice ? displayTotalPrice : displayPrice}
                    from={currency}
                />
                {totalPrice && (<span className={s.totalBeforeTaxText}> <FormattedMessage {...messages.totalBeforeTaxes} /> </span>)}
            </>
        )
    }
}

export default ShowPrice;